export enum BusinessException {
  INTERACTION_STATUS_NOT_ALLOWED = 'Essa interação já foi avaliada.',
  INTERACTION_ITEM_STATUS_NOT_ALLOWED = 'Os itens dessa interação já foram avaliados.',
  PENDING_REVISION_NOT_FILTERED = 'O status de revisão ou pendente deve ser utilizado no filtro.',
  CANT_REMOVE_SEGMENT_OPERATION = 'Operação possui chamadas importadas e não está vinculada a outro segmento.',
  FLOW_NOT_FOUND = 'Fluxo não encontrado. Verifique as configurações para o Segmento e Operação dessa Interação.',
  INTERACTION_ALREADY_UPDATED = 'Monitoria já alterada, favor atualizar a página e tentar novamente.',
  SPEECH_ENVIRONMENT_DOESNT_EXISTS = 'O ambiente Speech vinculado ao segmento não existe.',
}
